import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Connecticut State Portal": {
    parameters: {
      linkUrls: ["https://connecticut.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "CT",
  },
  "Connecticut Portal Newly Not Reporting": {
    parameters: {
      staffInputs: {
        documentTypes: {
          proof: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "CT",
  },
};
